export const SQUARE_DATA_CONVERSIONS = {
  "Period Start": (str) => str.split(":")[1].replace(" ", ""),
  "Period End": (str) => str.split(":")[1].replace(" ", ""),
  "Payday": (str) => str.split(":")[1].replace(" ", ""),
  "Workplace ID": (str) => (str.split(":")[1].substring(1)).split(",")[0],
}

